"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _VarsConvert = require("./VarsConvert");
Object.keys(_VarsConvert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsConvert[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsConvert[key];
    }
  });
});
var _VarsDynamicVariable = require("./VarsDynamicVariable");
Object.keys(_VarsDynamicVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsDynamicVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsDynamicVariable[key];
    }
  });
});
var _VarsParameter = require("./VarsParameter");
Object.keys(_VarsParameter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsParameter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsParameter[key];
    }
  });
});
var _VarsParameters = require("./VarsParameters");
Object.keys(_VarsParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsParameters[key];
    }
  });
});
var _VarsValue = require("./VarsValue");
Object.keys(_VarsValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsValue[key];
    }
  });
});
var _VarsVariableConfig = require("./VarsVariableConfig");
Object.keys(_VarsVariableConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableConfig[key];
    }
  });
});
var _VarsCondition = require("./VarsCondition");
Object.keys(_VarsCondition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsCondition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsCondition[key];
    }
  });
});
var _VarsConversionDate = require("./VarsConversionDate");
Object.keys(_VarsConversionDate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsConversionDate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsConversionDate[key];
    }
  });
});
var _VarsConversionDecimals = require("./VarsConversionDecimals");
Object.keys(_VarsConversionDecimals).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsConversionDecimals[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsConversionDecimals[key];
    }
  });
});
var _VarsConversionJson = require("./VarsConversionJson");
Object.keys(_VarsConversionJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsConversionJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsConversionJson[key];
    }
  });
});
var _VarsConversionMapping = require("./VarsConversionMapping");
Object.keys(_VarsConversionMapping).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsConversionMapping[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsConversionMapping[key];
    }
  });
});
var _VarsConversionTimeDifference = require("./VarsConversionTimeDifference");
Object.keys(_VarsConversionTimeDifference).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsConversionTimeDifference[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsConversionTimeDifference[key];
    }
  });
});
var _VarsReferenceConstant = require("./VarsReferenceConstant");
Object.keys(_VarsReferenceConstant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsReferenceConstant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsReferenceConstant[key];
    }
  });
});
var _VarsReference = require("./VarsReference");
Object.keys(_VarsReference).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsReference[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsReference[key];
    }
  });
});
var _VarsReferenceVariable = require("./VarsReferenceVariable");
Object.keys(_VarsReferenceVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsReferenceVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsReferenceVariable[key];
    }
  });
});
var _VarsArgumentsConfig = require("./VarsArgumentsConfig");
Object.keys(_VarsArgumentsConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsArgumentsConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsArgumentsConfig[key];
    }
  });
});
var _VarsVariableBalance = require("./VarsVariableBalance");
Object.keys(_VarsVariableBalance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableBalance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableBalance[key];
    }
  });
});
var _VarsVariableCall = require("./VarsVariableCall");
Object.keys(_VarsVariableCall).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableCall[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableCall[key];
    }
  });
});
var _VarsVariableCollectionItem = require("./VarsVariableCollectionItem");
Object.keys(_VarsVariableCollectionItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableCollectionItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableCollectionItem[key];
    }
  });
});
var _VarsVariableCollection = require("./VarsVariableCollection");
Object.keys(_VarsVariableCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableCollection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableCollection[key];
    }
  });
});
var _VarsVariableCondition = require("./VarsVariableCondition");
Object.keys(_VarsVariableCondition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableCondition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableCondition[key];
    }
  });
});
var _VarsVariableContract = require("./VarsVariableContract");
Object.keys(_VarsVariableContract).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableContract[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableContract[key];
    }
  });
});
var _VarsVariableDumbappArguments = require("./VarsVariableDumbappArguments");
Object.keys(_VarsVariableDumbappArguments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableDumbappArguments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableDumbappArguments[key];
    }
  });
});
var _VarsVariableImage = require("./VarsVariableImage");
Object.keys(_VarsVariableImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableImage[key];
    }
  });
});
var _VarsVariableInteraction = require("./VarsVariableInteraction");
Object.keys(_VarsVariableInteraction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableInteraction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableInteraction[key];
    }
  });
});
var _VarsVariableLiteral = require("./VarsVariableLiteral");
Object.keys(_VarsVariableLiteral).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableLiteral[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableLiteral[key];
    }
  });
});
var _VarsVariableMath = require("./VarsVariableMath");
Object.keys(_VarsVariableMath).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableMath[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableMath[key];
    }
  });
});
var _VarsVariableNft = require("./VarsVariableNft");
Object.keys(_VarsVariableNft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableNft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableNft[key];
    }
  });
});
var _VarsVariableOwnedNfts = require("./VarsVariableOwnedNfts");
Object.keys(_VarsVariableOwnedNfts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableOwnedNfts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableOwnedNfts[key];
    }
  });
});
var _VarsVariableParameter = require("./VarsVariableParameter");
Object.keys(_VarsVariableParameter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableParameter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableParameter[key];
    }
  });
});
var _VarsVariablePointer = require("./VarsVariablePointer");
Object.keys(_VarsVariablePointer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariablePointer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariablePointer[key];
    }
  });
});
var _VarsVariableRepeat = require("./VarsVariableRepeat");
Object.keys(_VarsVariableRepeat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableRepeat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableRepeat[key];
    }
  });
});
var _VarsVariableRootContract = require("./VarsVariableRootContract");
Object.keys(_VarsVariableRootContract).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableRootContract[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableRootContract[key];
    }
  });
});
var _VarsVariableRootParameter = require("./VarsVariableRootParameter");
Object.keys(_VarsVariableRootParameter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableRootParameter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableRootParameter[key];
    }
  });
});
var _VarsVariableTemplate = require("./VarsVariableTemplate");
Object.keys(_VarsVariableTemplate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableTemplate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableTemplate[key];
    }
  });
});
var _VarsVariableWallet = require("./VarsVariableWallet");
Object.keys(_VarsVariableWallet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableWallet[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableWallet[key];
    }
  });
});
//# sourceMappingURL=index.js.map